(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6637],{

/***/ 61611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2248);
/* harmony import */ var _commons_layouts_SectionLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7419);
/* harmony import */ var configs_space__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21998);
/* harmony import */ var lib_getSpacePrice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83579);
/* harmony import */ var _CostSection_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80208);
/* harmony import */ var _CostSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_CostSection_module_scss__WEBPACK_IMPORTED_MODULE_5__);



// configs

// hooks


var CostSection = function(param) {
    var _countryCode = param.countryCode, countryCode = _countryCode === void 0 ? "jpn" : _countryCode;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    var isJapan = countryCode === "jpn";
    var CostItem = function(param) {
        var title = param.title, cost = param.cost, description = param.description, imageUrl = param.imageUrl, imageAlt = param.imageAlt;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_CostSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_CostSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().itemHeading),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_CostSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().itemPriceBox),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: (_CostSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().itemPriceBoxTitle),
                                    children: title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_CostSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().itemPriceBoxDescription),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_CostSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().itemPrice),
                                        children: [
                                            cost,
                                            isJapan && "〜",
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                children: [
                                                    "/",
                                                    t("TOP.COST.PER.DAY")
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: imageUrl,
                            alt: imageAlt
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_CostSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().itemDescription),
                    children: description
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_commons_layouts_SectionLayout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        sectionName: "cost",
        sectionImageAlt: t("META.COST"),
        title: t("TOP.COST.TITLE"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_CostSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().costItems),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_CostSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().costItemsPlan),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CostItem, {
                            title: t("TOP.COST.BAGSIZE"),
                            cost: (0,lib_getSpacePrice__WEBPACK_IMPORTED_MODULE_4__/* .getSpacePrice */ .Q)(countryCode, configs_space__WEBPACK_IMPORTED_MODULE_3__/* .PRICE_SIZE_TYPE_BAG */ .F$),
                            description: t("TOP.COST.BAG.DESCRIPTION"),
                            imageUrl: "/cost_bag_size_group.webp",
                            imageAlt: t("META.COST_BAG_SIZE_GROUP")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CostItem, {
                            title: t("TOP.COST.SUITCASESIZE"),
                            cost: (0,lib_getSpacePrice__WEBPACK_IMPORTED_MODULE_4__/* .getSpacePrice */ .Q)(countryCode, configs_space__WEBPACK_IMPORTED_MODULE_3__/* .PRICE_SIZE_TYPE_SUITCASE */ .TD),
                            description: t("TOP.COST.SUITCASE.DESCRIPTION"),
                            imageUrl: "/cost_suitcase_size_group.webp",
                            imageAlt: t("META.COST_SUITCASE_SIZE_GROUP")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_CostSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().costNote),
                    children: [
                        isJapan && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_CostSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().costNoteDisclaimer),
                            children: t("TOP.COST.NOTE.DISCLAIMER")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_CostSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().costNoteTitle),
                            children: t("TOP.COST.NOTE.TITLE")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_CostSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().costNoteDescription),
                            children: t("TOP.COST.NOTE.DESCRIPTION.ONE")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_CostSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().costNoteDescription),
                            children: t("TOP.COST.NOTE.DESCRIPTION.TWO")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CostSection);


/***/ }),

/***/ 87396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2248);
/* harmony import */ var lib_addLocalePrefix__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57467);
/* harmony import */ var _commons_layouts_SectionLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7419);
/* harmony import */ var _CountrySection_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78114);
/* harmony import */ var _CountrySection_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_CountrySection_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var CountrySection = function(param) {
    var countries = param.countries, _locale = param.locale, locale = _locale === void 0 ? "ja" : _locale;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    /**
   * srcのデータを渡して
   * css background の値を取得する
   * @param string src 画像URL
   * @returns string background style
   */ var backgroundStyle = function(country_code) {
        var src = country_code === "jpn" ? "/country_jp.webp" : "/country_tw.webp";
        return 'url("'.concat(src, '") no-repeat');
    };
    /**
   * 言語によって表示するものを切り替える
   * @param { country } Country 国情報
   * @returns
   */ var getName = function(param) {
        var country_code = param.country_code, name = param.name;
        if (country_code === "jpn") return t("TOP.COUNTRY.JP");
        else if (country_code === "twn") return t("TOP.COUNTRY.TW");
        else return name;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_commons_layouts_SectionLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        sectionName: "country",
        title: t("TOP.COUNTRY.TITLE"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: countries.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: (_CountrySection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().countryItems),
                children: countries.map(function(country, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: (_CountrySection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item),
                        style: {
                            background: backgroundStyle(country.country_code),
                            backgroundSize: "cover"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_CountrySection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().itemOverlay),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: (0,lib_addLocalePrefix__WEBPACK_IMPORTED_MODULE_3__/* .addLocalePrefix */ .Le)("/".concat(country.country_code), locale),
                                passHref: true,
                                legacyBehavior: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: (_CountrySection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().areaNameLink),
                                    children: getName(country)
                                })
                            })
                        })
                    }, index);
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CountrySection);


/***/ }),

/***/ 32938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2248);
/* harmony import */ var _commons_layouts_SectionLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7419);
/* harmony import */ var lib_checkBreakpoint__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92122);
/* harmony import */ var _FeatureSection_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38937);
/* harmony import */ var _FeatureSection_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_FeatureSection_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var FeatureSection = function(param) {
    var _countryCode = param.countryCode, countryCode = _countryCode === void 0 ? "jpn" : _countryCode;
    var isMobile = (0,lib_checkBreakpoint__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isMobile;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    // 特徴 - マップアイコン
    var imageMapIcon = countryCode === "twn" ? "/feature_map_twn.webp" : "/feature_map.webp";
    var FeatureItem = function(param) {
        var image = param.image, imageAlt = param.imageAlt, title = param.title, description = param.description;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_FeatureSection_module_scss__WEBPACK_IMPORTED_MODULE_4___default().item),
            children: isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_FeatureSection_module_scss__WEBPACK_IMPORTED_MODULE_4___default().itemHeading),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: image,
                                alt: imageAlt
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_FeatureSection_module_scss__WEBPACK_IMPORTED_MODULE_4___default().itemTitle),
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_FeatureSection_module_scss__WEBPACK_IMPORTED_MODULE_4___default().itemDesc),
                        children: description
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_FeatureSection_module_scss__WEBPACK_IMPORTED_MODULE_4___default().itemImage),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: image,
                            alt: imageAlt
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_FeatureSection_module_scss__WEBPACK_IMPORTED_MODULE_4___default().itemTextBundle),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_FeatureSection_module_scss__WEBPACK_IMPORTED_MODULE_4___default().itemTitle),
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_FeatureSection_module_scss__WEBPACK_IMPORTED_MODULE_4___default().itemDesc),
                                children: description
                            })
                        ]
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_commons_layouts_SectionLayout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        sectionName: "feature",
        sectionImageAlt: t("META.FEATURES"),
        title: t("TOP.FEATURES.TITLE"),
        style: (_FeatureSection_module_scss__WEBPACK_IMPORTED_MODULE_4___default().section),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_FeatureSection_module_scss__WEBPACK_IMPORTED_MODULE_4___default().featureItems),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_FeatureSection_module_scss__WEBPACK_IMPORTED_MODULE_4___default().featureItemsSection),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeatureItem, {
                            image: imageMapIcon,
                            imageAlt: t("META.FEATURE_MAP"),
                            title: t("TOP.FEATURES.HEADING.SPACE"),
                            description: t("TOP.FEATURES.DESCRIPTION.SPACE")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeatureItem, {
                            image: "/feature_map_pin.webp",
                            imageAlt: t("META.FEATURE_MAP_PIN"),
                            title: t("TOP.FEATURES.HEADING.LOCATION"),
                            description: t("TOP.FEATURES.DESCRIPTION.LOCATION")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_FeatureSection_module_scss__WEBPACK_IMPORTED_MODULE_4___default().featureItemsSection),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeatureItem, {
                            image: "/feature_musical_instrument.webp",
                            imageAlt: t("META.FEATURE_MUSICAL_INSTRUMENT"),
                            title: t("TOP.FEATURES.HEADING.MUSICAL_INSTRUMENT"),
                            description: t("TOP.FEATURES.DESCRIPTION.MUSICAL_INSTRUMENT")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeatureItem, {
                            image: "/feature_payment.webp",
                            imageAlt: t("META.FEATURE_PAYMENT"),
                            title: t("TOP.FEATURES.HEADING.COMPENSATION"),
                            description: t("TOP.FEATURES.DESCRIPTION.COMPENSATION")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FeatureSection);


/***/ }),

/***/ 3107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2248);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lib_addLocalePrefix__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57467);
/* harmony import */ var _commons_layouts_SectionLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7419);
/* harmony import */ var _AreaPrefectureList__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68082);
/* harmony import */ var _AreaPlaceList__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18074);
/* harmony import */ var hooks_common_lang__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16529);
/* harmony import */ var _LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59175);
/* harmony import */ var _LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9__);









// hooks


var LocationDisplaySection = function(param) {
    var locations = param.locations, prefectures = param.prefectures, locale = param.locale, _countryCode = param.countryCode, countryCode = _countryCode === void 0 ? "jpn" : _countryCode, onScrollLocation = param.onScrollLocation;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(), selectedPrefecture = ref[0], setSelectedPrefecture = ref[1];
    var prefectureAreas = prefectures !== null && prefectures !== void 0 ? prefectures : [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_commons_layouts_SectionLayout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        sectionName: "location",
        title: t("TOP.LOCATION.TITLE"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().prefectures), " ").concat(!!selectedPrefecture && (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().prefecturesSelected)),
                children: prefectureAreas.map(function(item, index) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: item.prefectures.map(function(prefecture, index) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().selectedAreaWrap), " ").concat((selectedPrefecture === null || selectedPrefecture === void 0 ? void 0 : selectedPrefecture.slug) === prefecture.slug ? (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().selectedAreaWrapSelected) : ""),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().selectedArea),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().backList),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().btnBack),
                                                onClick: function() {
                                                    return setSelectedPrefecture(null);
                                                },
                                                type: "button",
                                                children: t("TOP.LOCATION.BACK_BUTTON_TEXT")
                                            })
                                        }),
                                        (selectedPrefecture === null || selectedPrefecture === void 0 ? void 0 : selectedPrefecture.slug) === prefecture.slug && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().areaName),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                href: (0,lib_addLocalePrefix__WEBPACK_IMPORTED_MODULE_5__/* .addLocalePrefix */ .Le)("/".concat(countryCode, "/city/").concat(prefecture.slug), locale),
                                                legacyBehavior: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().areaNameLink),
                                                    children: t("TOP.LOCATION.PREFECTURE_AREA_LABEL", {
                                                        prefecture: prefecture.name
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AreaPlaceList__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            prefectureSlug: prefecture.slug,
                                            places: prefecture.stations,
                                            label: t("TOP.LOCATION.STATION_LABEL"),
                                            countryCode: countryCode,
                                            locale: locale
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().stationsContent),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AreaPlaceList__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                prefectureSlug: prefecture.slug,
                                                places: prefecture.facilities,
                                                label: t("TOP.LOCATION.FACILITY_LABEL"),
                                                countryCode: countryCode,
                                                locale: locale
                                            })
                                        })
                                    ]
                                })
                            }, index);
                        })
                    });
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat((_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().areaItemsWrap), " ").concat(!!selectedPrefecture && (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().areaItemsWrapSelected)),
                children: [
                    (locations === null || locations === void 0 ? void 0 : locations.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().locationsItems),
                        children: locations.map(function(location, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().item),
                                style: {
                                    background: location.backgroundImage,
                                    backgroundSize: "cover"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().itemOverlay),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: (0,lib_addLocalePrefix__WEBPACK_IMPORTED_MODULE_5__/* .addLocalePrefix */ .Le)("/jpn/city/".concat(location.slug), locale),
                                        passHref: true,
                                        legacyBehavior: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().areaNameLink),
                                            children: location.name
                                        })
                                    })
                                })
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().areaItems),
                        children: [
                            countryCode === "jpn" && prefectureAreas.length > 0 && prefectureAreas.map(function(prefecture, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().areaItem),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AreaPrefectureList__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        areaName: (0,hooks_common_lang__WEBPACK_IMPORTED_MODULE_10__/* .getAreaName */ .kB)(locale, prefecture),
                                        prefectures: prefecture.prefectures,
                                        onSelectAreaName: function(_prefecture) {
                                            setSelectedPrefecture(_prefecture);
                                            onScrollLocation();
                                        },
                                        locale: locale,
                                        countryCode: countryCode
                                    })
                                }, index);
                            }),
                            countryCode === "twn" && prefectureAreas.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().gridLocationContainer),
                                    children: prefectureAreas.map(function(item, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().location),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().area),
                                                    children: item.area_name
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().cityContainer),
                                                    children: (item.prefectures || []).map(function(prefecture, index) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            onClick: function() {
                                                                return next_router__WEBPACK_IMPORTED_MODULE_4___default().push((0,lib_addLocalePrefix__WEBPACK_IMPORTED_MODULE_5__/* .addLocalePrefix */ .Le)("/twn/city/".concat(prefecture.slug), locale));
                                                            },
                                                            className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_9___default().city),
                                                            children: prefecture.name
                                                        }, index);
                                                    })
                                                })
                                            ]
                                        }, index);
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LocationDisplaySection);


/***/ }),

/***/ 22803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ top_MainBannerSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/index.js
var react_multi_carousel = __webpack_require__(86529);
;// CONCATENATED MODULE: ./src/components/domains/top/MainBannerSection.constants.ts
var APP_DOWNLOAD_URL = "https://ecbocloak.go.link/ff1OV";

// EXTERNAL MODULE: ./src/components/domains/top/MainBannerSection.module.scss
var MainBannerSection_module = __webpack_require__(92212);
var MainBannerSection_module_default = /*#__PURE__*/__webpack_require__.n(MainBannerSection_module);
;// CONCATENATED MODULE: ./src/components/domains/top/MainBannerSection.tsx





var responsive = {
    desktop: {
        breakpoint: {
            max: 3000,
            min: 992
        },
        items: 1
    },
    tablet: {
        breakpoint: {
            max: 3000,
            min: 576
        },
        items: 1
    },
    mobile: {
        breakpoint: {
            max: 575,
            min: 0
        },
        items: 1
    }
};
var MainBannerSection = function(param) {
    var locale = param.locale;
    /**
   * @TODO
   * 将来的にAdminから取得するように対応
   */ var banners = (0,react.useMemo)(function() {
        return [
            {
                name: {
                    en: "Leave your luggage with us and get crispy and comfortable! Download the app first!",
                    ja: "荷物を預けてサクサク快適！まずはアプリをダウンロード"
                },
                image_pc: "/banner_ecbo_app_pc.webp",
                image_sp: "/banner_ecbo_app_sp.webp",
                url: APP_DOWNLOAD_URL
            },
            {
                name: {
                    en: "HOW TO - Click here to learn how to use ecbo cloak.",
                    ja: "HOW TO - ecbo cloakの使い方はこちら"
                },
                image_pc: "/banner_ecbo_beginner_pc.webp",
                image_sp: "/banner_ecbo_beginner_sp.webp",
                url: "https://ecbonist.ecbo.io/how_to_use_ecbo_cloak/"
            },
            {
                name: {
                    en: "TOKYO MARINE NICHIDO Tokio Marine Nichido in cooperation with ecbo clock - ecbo clock loss insurance covers up to 200,000 yen (*Some deductibles apply)",
                    ja: "TOKYO MARINE NICHIDO 東京海上日動とecbo clockの提携 - ecbo clockの紛失保険なら最大20万円まで保証(※一部免責金額等があります)"
                },
                image_pc: "/banner_ecbo_insurance_pc.webp",
                image_sp: "/banner_ecbo_insurance_sp.webp",
                url: "https://intercom.help/ecbocloak/ja/articles/9333901"
            }, 
        ];
    }, []);
    var CustomDot = (0,react.useCallback)(function(param) {
        var onClick = param.onClick, active = param.active;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            className: "".concat((MainBannerSection_module_default()).mainBannersDotsItem, " ").concat(active ? (MainBannerSection_module_default()).mainBannersDotsItemActive : ""),
            onClick: function() {
                return onClick();
            }
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (MainBannerSection_module_default()).mainBannerSection,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_multi_carousel["default"], {
            responsive: responsive,
            autoPlay: false,
            infinite: true,
            swipeable: true,
            className: (MainBannerSection_module_default()).mainBanners,
            arrows: false,
            showDots: true,
            autoPlaySpeed: 3000,
            dotListClass: (MainBannerSection_module_default()).mainBannersDots,
            customDot: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomDot, {}),
            children: banners.map(function(banner, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: function() {
                        return window.open(banner.url, "_blank");
                    },
                    className: (MainBannerSection_module_default()).bannerContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (MainBannerSection_module_default()).bannerPC,
                            style: {
                                backgroundImage: "url(".concat(banner.image_pc, ")")
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (MainBannerSection_module_default()).bannerMobile,
                            style: {
                                backgroundImage: "url(".concat(banner.image_sp, ")")
                            }
                        })
                    ]
                }, index);
            })
        })
    });
};
/* harmony default export */ var top_MainBannerSection = (MainBannerSection);


/***/ }),

/***/ 94738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2248);
/* harmony import */ var lib_checkBreakpoint__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92122);
/* harmony import */ var _OwnerSection_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33030);
/* harmony import */ var _OwnerSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_OwnerSection_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);






var OwnerSection = function() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var isDesktop = (0,lib_checkBreakpoint__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isDesktop;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_OwnerSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().ownerSection),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_OwnerSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().ownerSectionBox),
            children: [
                isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/owner_section_illustration.webp",
                    alt: t("META.OWNER_SECTION_ILLUSTRATION")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_OwnerSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().ownerSectionBoxTitle),
                    children: t("TOP.OWNER.TITLE")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: (_OwnerSection_module_scss__WEBPACK_IMPORTED_MODULE_5___default().ownerSectionBoxButton),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "https://join-cloak.ecbo.io/owner".concat(locale === "zh-TW" ? "/".concat(locale) : ""),
                        passHref: true,
                        legacyBehavior: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noreferrer",
                            children: t("TOP.OWNER.REGISTER")
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OwnerSection);


/***/ }),

/***/ 91249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ top_ReviewSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 13 modules
var esm = __webpack_require__(2248);
// EXTERNAL MODULE: ./node_modules/react-multi-carousel/index.js
var react_multi_carousel = __webpack_require__(86529);
// EXTERNAL MODULE: ./src/components/commons/layouts/SectionLayout.tsx
var SectionLayout = __webpack_require__(7419);
// EXTERNAL MODULE: ./src/components/ratings/RatingComponent.tsx
var RatingComponent = __webpack_require__(27445);
// EXTERNAL MODULE: ./src/components/domains/top/ReviewCard.module.scss
var ReviewCard_module = __webpack_require__(90441);
var ReviewCard_module_default = /*#__PURE__*/__webpack_require__.n(ReviewCard_module);
;// CONCATENATED MODULE: ./src/components/domains/top/ReviewCard.tsx



var ReviewCard = function(param) {
    var review = param.review;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ReviewCard_module_default()).item,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ReviewCard_module_default()).itemInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ReviewCard_module_default()).itemInfoUserName,
                        children: review.user_name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingComponent/* default */.Z, {
                        averageRating: review.rating
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (ReviewCard_module_default()).itemDescription,
                children: review.review_comment
            })
        ]
    }, review.id);
};
/* harmony default export */ var top_ReviewCard = (ReviewCard);

// EXTERNAL MODULE: ./src/components/domains/top/ReviewSection.module.scss
var ReviewSection_module = __webpack_require__(78858);
var ReviewSection_module_default = /*#__PURE__*/__webpack_require__.n(ReviewSection_module);
// EXTERNAL MODULE: ./src/lib/checkBreakpoint.ts
var checkBreakpoint = __webpack_require__(92122);
;// CONCATENATED MODULE: ./src/data/user_reviews.json
var user_reviews_namespaceObject = JSON.parse('{"ja":[{"id":1,"user_name":"たか子","rating":5,"review_comment":"大きなスーツケースを平日預かって貰えて助かりました。\\nお陰で身軽に観光することが出来ました。"},{"id":2,"user_name":"恵理","rating":5,"review_comment":"楽器(スーツケースサイズ)を預けたくて、初めて利用しました！\\nコインロッカーより安くて、店舗自体もすごくキレイだったので、少しくつろいじゃいました。"},{"id":3,"user_name":"Ayumi","rating":5,"review_comment":"近くでライブイベントがあり、その間ベビーカーを預かって頂きました。息子のオムツ替えスペースも提供して頂き本当に助かりました！とても親切にして頂きまして、感謝しております。とても良い一日になりました。"},{"id":4,"user_name":"成美","rating":5,"review_comment":"丁寧に対応していただき、またチェックアウト時もチェックインした時のスタッフさんがすぐに気づいてくださってさすがだなあ、と思いつました。"},{"id":5,"user_name":"絵里子","rating":5,"review_comment":"駅のコインロッカーが全滅でどうしようかと途方にくれていたところ、このサイトを知りました。検索かけた所こちらがすぐに見つかり、利用しました。"},{"id":6,"user_name":"けい","rating":5,"review_comment":"散策の為にベビーカーを預けました。ベビーカーを畳まずに置かせて頂け、とても助かりました。"},{"id":7,"user_name":"理","rating":5,"review_comment":"急な依頼にもかかわらず快く受け付けていただきました。\\n食事も美味しかったです。また利用させていただきたいと思います。"},{"id":8,"user_name":"圭一","rating":5,"review_comment":"駅も近く、安心して預ける事ができました。\\n預けたものが、ギターだったので、なかなか預けられる所もなく、持ち歩くには重くかさばるので、大変助かりました。"},{"id":9,"user_name":"優真","rating":5,"review_comment":"とても対応もよく安心して荷物を預けることができた。ありがとうございました。"}],"en":[{"id":1,"user_name":"Monique","rating":5,"review_comment":"Easy check-in and out. You show them the confirmation page. Then they will take pictures of the luggage & done. 10/10"},{"id":2,"user_name":"Willie","rating":5,"review_comment":"very convenience service, nice assistant very helpful.👍👍"},{"id":3,"user_name":"Fransisco","rating":5,"review_comment":"Super easy and safe way to place your luggages while your away. By easy, I really mean it. No hassle at all."},{"id":4,"user_name":"Fransisco","rating":5,"review_comment":"The staff was friendly.Convenient location and easy managed.Cool"},{"id":5,"user_name":"Lang","rating":5,"review_comment":"Easy and convenient, much better than looking for lockers especially when you\'re moving with a few big suitcases."},{"id":6,"user_name":"Simon","rating":5,"review_comment":"Very helpful and capable staff. We were extraordinarily surprised. Recommended! "},{"id":7,"user_name":"Rex","rating":5,"review_comment":"Very good! Easy to find, good service, I must use again next time"},{"id":8,"user_name":"Daniel","rating":5,"review_comment":"Very nice store owners, was able to leave 4 suit cases with them. location was easy to get to."},{"id":9,"user_name":"Roni","rating":5,"review_comment":"they were very helpful! the car service we ordered in advance was cancelled last minute and they got us a large taxi! "}]}');
;// CONCATENATED MODULE: ./src/components/domains/top/ReviewSection.tsx








var ReviewSection = function() {
    var ref = (0,esm/* useTranslation */.$G)(), t = ref.t, i18n = ref.i18n;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionLayout/* default */.Z, {
        sectionName: "review",
        sectionImageAlt: t("META.REVIEW"),
        title: t("COMMON.REVIEW_LABEL"),
        style: (ReviewSection_module_default()).section,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_multi_carousel["default"], {
            ssr: true,
            responsive: checkBreakpoint/* responsive */.j,
            infinite: true,
            swipeable: true,
            className: (ReviewSection_module_default()).reviewItems,
            customLeftArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ReviewSection_module_default()).prev
            }),
            customRightArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ReviewSection_module_default()).next
            }),
            children: user_reviews_namespaceObject[i18n.language === "zh-TW" ? "en" : i18n.language].map(function(review) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(top_ReviewCard, {
                    review: review
                }, review.id);
            })
        })
    });
};
/* harmony default export */ var top_ReviewSection = (ReviewSection);


/***/ }),

/***/ 75920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2248);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_domains_spaces_SearchForm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4816);
/* harmony import */ var _SearchSection_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80962);
/* harmony import */ var _SearchSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_SearchSection_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_5__);







var SearchSection = function(param) {
    var locale = param.locale, _countryCode = param.countryCode, countryCode = _countryCode === void 0 ? "jpn" : _countryCode;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var _onPressNavigationSearchSpacePage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value, selectedDate, startDateTime, endDateTime, bagSize, suitcaseSize, lat, lon, isLocation) {
        router.push({
            pathname: "/locations",
            query: {
                name: value,
                startDate: selectedDate.startDate ? selectedDate.startDate.format("YYYY-MM-DD") : moment__WEBPACK_IMPORTED_MODULE_5___default()().format("YYYY-MM-DD"),
                endDate: selectedDate.endDate ? selectedDate.endDate.format("YYYY-MM-DD") : moment__WEBPACK_IMPORTED_MODULE_5___default()().format("YYYY-MM-DD"),
                startDateTimeHour: startDateTime.substring(0, startDateTime.indexOf(":")),
                startDateTimeMin: startDateTime.substring(startDateTime.indexOf(":") + 1),
                endDateTimeHour: endDateTime.substring(0, endDateTime.indexOf(":")),
                endDateTimeMin: endDateTime.substring(endDateTime.indexOf(":") + 1),
                bagSize: bagSize,
                suitcaseSize: suitcaseSize ? suitcaseSize : 1,
                lat: lat,
                lon: lon,
                isLocation: isLocation
            }
        });
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "".concat((_SearchSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().searchSection), " ").concat(countryCode === "twn" ? (_SearchSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().searchSectionCountryTwn) : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_SearchSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().searchSectionHeading),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: (_SearchSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().searchSectionHeadingTitle),
                        children: t("TOP.TITLE")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_SearchSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().searchSectionHeadingSubTitle),
                        children: t("TOP.SUBTITLE")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_SearchSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().searchArea),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_SearchSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().searchAreaContent),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_domains_spaces_SearchForm__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        page: "top",
                        onPressNavigationSearchSpacePage: _onPressNavigationSearchSpacePage,
                        locale: locale
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SearchSection);


/***/ }),

/***/ 33396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2248);
/* harmony import */ var _buttons_AppStoreButtonComponent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32468);
/* harmony import */ var _buttons_GooglePlayButtonComponent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2168);
/* harmony import */ var _StoreSection_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65089);
/* harmony import */ var _StoreSection_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_StoreSection_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var StoreSection = function(param) {
    var style = param.style;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "".concat((_StoreSection_module_scss__WEBPACK_IMPORTED_MODULE_4___default().storeSection), " ").concat(style ? style : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_StoreSection_module_scss__WEBPACK_IMPORTED_MODULE_4___default().storeSectionArea),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_StoreSection_module_scss__WEBPACK_IMPORTED_MODULE_4___default().storeSectionTitle),
                        children: t("TOP.STORE.TITLE")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_StoreSection_module_scss__WEBPACK_IMPORTED_MODULE_4___default().storeSectionBanner),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttons_AppStoreButtonComponent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttons_GooglePlayButtonComponent__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    className: (_StoreSection_module_scss__WEBPACK_IMPORTED_MODULE_4___default().storeSectionImage),
                    src: "/app_main_visual.webp",
                    alt: t("META.APP_MAIN_VISUAL")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StoreSection);


/***/ }),

/***/ 16822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2248);
/* harmony import */ var _commons_layouts_SectionLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7419);
/* harmony import */ var _UsageSection_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18369);
/* harmony import */ var _UsageSection_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_UsageSection_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var UsageSection = function(param) {
    var style = param.style;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    var UsageItem = function(param) {
        var numberImage = param.numberImage, numberAlt = param.numberAlt, itemImage = param.itemImage, itemImageAlt = param.itemImageAlt, itemText = param.itemText;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_UsageSection_module_scss__WEBPACK_IMPORTED_MODULE_3___default().item),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_UsageSection_module_scss__WEBPACK_IMPORTED_MODULE_3___default().itemNumber),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: numberImage,
                        alt: numberAlt
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: itemImage,
                    alt: itemImageAlt
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_UsageSection_module_scss__WEBPACK_IMPORTED_MODULE_3___default().itemText),
                    children: itemText
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_commons_layouts_SectionLayout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        sectionName: "usage",
        sectionImageAlt: t("META.HOW_TO_USE"),
        title: t("TOP.USAGE.TITLE"),
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_UsageSection_module_scss__WEBPACK_IMPORTED_MODULE_3___default().usageItems),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UsageItem, {
                    numberImage: "/how_to_number_1.webp",
                    numberAlt: t("META.HOW_TO_NUMBER_1"),
                    itemImage: "/how_to_1.webp",
                    itemImageAlt: t("META.HOW_TO_1"),
                    itemText: t("TOP.USAGE.SCENE.ONE")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UsageItem, {
                    numberImage: "/how_to_number_2.webp",
                    numberAlt: t("META.HOW_TO_NUMBER_2"),
                    itemImage: "/how_to_2.webp",
                    itemImageAlt: t("META.HOW_TO_2"),
                    itemText: t("TOP.USAGE.SCENE.TWO")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UsageItem, {
                    numberImage: "/how_to_number_3.webp",
                    numberAlt: t("META.HOW_TO_NUMBER_3"),
                    itemImage: "/how_to_3.webp",
                    itemImageAlt: t("META.HOW_TO_3"),
                    itemText: t("TOP.USAGE.SCENE.THREE")
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UsageSection);


/***/ }),

/***/ 21998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F$": function() { return /* binding */ PRICE_SIZE_TYPE_BAG; },
/* harmony export */   "Id": function() { return /* binding */ PRICE; },
/* harmony export */   "TD": function() { return /* binding */ PRICE_SIZE_TYPE_SUITCASE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var PRICE_SIZE_TYPE_BAG = "bag";
var PRICE_SIZE_TYPE_SUITCASE = "suitcase";
var _obj;
// 金額
var PRICE = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PRICE_SIZE_TYPE_BAG, {
    jpn: 500,
    en: 500,
    twn: 80
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PRICE_SIZE_TYPE_SUITCASE, {
    jpn: 800,
    en: 800,
    twn: 160
}), _obj);


/***/ }),

/***/ 23378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ useCountries; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 13 modules
var esm = __webpack_require__(2248);
// EXTERNAL MODULE: ./src/lib/axios.ts
var axios = __webpack_require__(61969);
;// CONCATENATED MODULE: ./src/features/country/services/countriesApi.ts



var API_COUNTRIES = "/api/web/countries";
var fetchCountries = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(locale) {
        var response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios/* ecboClient.get */.ZK.get(API_COUNTRIES, {
                            headers: {
                                "Accept-Language": (0,axios/* getHeaderLocale */.hi)(locale)
                            }
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        {
                            isOk: true,
                            data: response.data
                        }
                    ];
            }
        });
    });
    return function fetchCountries(locale) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/features/country/hooks/useCountries.ts







var useCountries = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _enabled = ref.enabled, enabled = _enabled === void 0 ? true : _enabled;
    var i18n = (0,esm/* useTranslation */.$G)().i18n;
    var ref1 = (0,react.useState)(null), countries = ref1[0], setCountries = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react.useState)(false), isError = ref3[0], setIsError = ref3[1];
    var loadCountries = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setLoading(true);
                    setIsError(false);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        fetchCountries(i18n.language)
                    ];
                case 2:
                    data = _state.sent().data;
                    setCountries(data.countries);
                    return [
                        3,
                        5
                    ];
                case 3:
                    error = _state.sent();
                    setIsError(true);
                    esm_exports/* captureException */.Tb((0,_instanceof/* default */.Z)(error, Error) ? error : new Error(String(error)), {
                        tags: {
                            hook: "useCountries"
                        },
                        extra: {
                            locale: i18n.language
                        }
                    });
                    return [
                        3,
                        5
                    ];
                case 4:
                    setLoading(false);
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        i18n.language
    ]);
    (0,react.useEffect)(function() {
        if (!enabled) return;
        loadCountries();
    }, [
        enabled,
        loadCountries
    ]);
    return {
        countries: countries,
        isLoading: isLoading,
        isError: isError,
        refetch: loadCountries
    };
};


/***/ }),

/***/ 83579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ getSpacePrice; }
/* harmony export */ });
/* harmony import */ var configs_space__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21998);
/* harmony import */ var state_ducks_space_models__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43340);


/**
 * 国コード、サイズの種類を判定して、金額を取得する
 * @param {string} country_code 国コード
 * @param {string} size_type サイズの種類
 * @returns
 */ var getSpacePrice = function() {
    var country_code = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "jpn", size_type = arguments.length > 1 ? arguments[1] : void 0;
    // 国コードの有効判定チェック
    var countryCodes = [
        "jpn",
        "twn"
    ];
    country_code = countryCodes.includes(country_code) ? country_code : "jpn";
    var price = configs_space__WEBPACK_IMPORTED_MODULE_0__/* .PRICE */ .Id[size_type][country_code];
    var currency = "";
    switch(country_code){
        case "jpn":
            currency = state_ducks_space_models__WEBPACK_IMPORTED_MODULE_1__/* .SpaceCurrency.cny */ .D4.cny;
            break;
        case "twn":
            currency = state_ducks_space_models__WEBPACK_IMPORTED_MODULE_1__/* .SpaceCurrency.twd */ .D4.twd;
            break;
        case "en":
            currency = state_ducks_space_models__WEBPACK_IMPORTED_MODULE_1__/* .SpaceCurrency.cny */ .D4.cny;
            break;
        default:
            currency = state_ducks_space_models__WEBPACK_IMPORTED_MODULE_1__/* .SpaceCurrency.cny */ .D4.cny;
            break;
    }
    return "".concat(currency).concat(price.toLocaleString());
};


/***/ }),

/***/ 80208:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","costItems":"CostSection_costItems__nhx_6","costItemsPlan":"CostSection_costItemsPlan__SvXn6","item":"CostSection_item__yclfI","itemHeading":"CostSection_itemHeading__Iu5qA","itemDescription":"CostSection_itemDescription__BwokF","itemPriceBox":"CostSection_itemPriceBox__nxDMm","itemPriceBoxTitle":"CostSection_itemPriceBoxTitle__DybvL","itemPrice":"CostSection_itemPrice__vj2s6","costNote":"CostSection_costNote__84Y_X","costNoteDisclaimer":"CostSection_costNoteDisclaimer__1xI4Y","costNoteDescription":"CostSection_costNoteDescription__VAxCy","costNoteTitle":"CostSection_costNoteTitle__FV8hV"};

/***/ }),

/***/ 78114:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","countryItems":"CountrySection_countryItems__TcI_f","item":"CountrySection_item__Xjttc","itemOverlay":"CountrySection_itemOverlay__l5iAw","areaNameLink":"CountrySection_areaNameLink__ZmRFo"};

/***/ }),

/***/ 38937:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","featureItems":"FeatureSection_featureItems__jZv5f","featureItemsSection":"FeatureSection_featureItemsSection__CJxnl","item":"FeatureSection_item__d2Qca","itemImage":"FeatureSection_itemImage__lcx_s","itemTitle":"FeatureSection_itemTitle__7DDoO","itemDesc":"FeatureSection_itemDesc__Qi6NO","section":"FeatureSection_section__8SPxy","itemHeading":"FeatureSection_itemHeading__r5fGo"};

/***/ }),

/***/ 92212:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","mainBannerSection":"MainBannerSection_mainBannerSection__ryCum","mainBanners":"MainBannerSection_mainBanners__S8jEV","mainBannersDots":"MainBannerSection_mainBannersDots__Si1Zu","mainBannersDotsItem":"MainBannerSection_mainBannersDotsItem__pcdHo","mainBannersDotsItemLink":"MainBannerSection_mainBannersDotsItemLink__UcY2Y","mainBannersDotsItemLinkImgSp":"MainBannerSection_mainBannersDotsItemLinkImgSp__zaiUa","mainBannersDotsItemLinkImgPc":"MainBannerSection_mainBannersDotsItemLinkImgPc__VnJ6F","mainBannersDotsItemActive":"MainBannerSection_mainBannersDotsItemActive__YGqjc","storeSection":"MainBannerSection_storeSection__RovRf","bannerPC":"MainBannerSection_bannerPC__v3uXv","bannerMobile":"MainBannerSection_bannerMobile__u0M2a"};

/***/ }),

/***/ 33030:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","ownerSection":"OwnerSection_ownerSection__TbJqM","ownerSectionBox":"OwnerSection_ownerSectionBox__I1viM","ownerSectionBoxTitle":"OwnerSection_ownerSectionBoxTitle__4KwcT","ownerSectionBoxButton":"OwnerSection_ownerSectionBoxButton__UEErN"};

/***/ }),

/***/ 90441:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","item":"ReviewCard_item__yf4Z_","itemInfo":"ReviewCard_itemInfo__iYfc2","itemInfoUserName":"ReviewCard_itemInfoUserName__LZyzJ","itemDescription":"ReviewCard_itemDescription__l6x8x"};

/***/ }),

/***/ 78858:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","reviewItems":"ReviewSection_reviewItems__iSh_8","prev":"ReviewSection_prev__lGcna","next":"ReviewSection_next__3LBQe","item":"ReviewSection_item__0Rh3Q","section":"ReviewSection_section__0n9M2"};

/***/ }),

/***/ 80962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","searchCurrent":"SearchSection_searchCurrent__YCPet","searchArea":"SearchSection_searchArea__jIU5V","searchAreaContent":"SearchSection_searchAreaContent__2Ck8i","searchSection":"SearchSection_searchSection__DpSi6","searchSectionHeading":"SearchSection_searchSectionHeading__4WEYG","searchSectionHeadingTitle":"SearchSection_searchSectionHeadingTitle__fA2uu","searchSectionHeadingSubTitle":"SearchSection_searchSectionHeadingSubTitle__vZ17B","searchSectionCountryTwn":"SearchSection_searchSectionCountryTwn__NQ_vo"};

/***/ }),

/***/ 65089:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","storeSection":"StoreSection_storeSection___B_uQ","storeSectionArea":"StoreSection_storeSectionArea__kqNo_","storeSectionTitle":"StoreSection_storeSectionTitle__B41p7","storeSectionBanner":"StoreSection_storeSectionBanner__i2o9G","storeSectionImage":"StoreSection_storeSectionImage__82MaF"};

/***/ }),

/***/ 18369:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","usageItems":"UsageSection_usageItems__x7CNz","item":"UsageSection_item__5UZXG","itemNumber":"UsageSection_itemNumber__EVOtg","itemText":"UsageSection_itemText__wuOdH"};

/***/ }),

/***/ 44301:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","wrap":"styles_wrap__izsu7","usageSection":"styles_usageSection__uIe_i"};

/***/ })

}]);